import type { NavigationStateLike } from "./types"

type ScreenTracker = ((screen: string) => void) | null

let screenTracker: ScreenTracker = null

/** Test seam + wiring point used by client.ts (avoids a client<->navigation import cycle). */
export function __setScreenTracker(fn: ScreenTracker): void {
  screenTracker = fn
}

/** Deepest focused route name from a React Navigation state object (also matches Expo Router shapes). */
export function getActiveRouteName(state: NavigationStateLike | null | undefined): string {
  if (!state || !Array.isArray(state.routes) || state.routes.length === 0) return ""
  const route = state.routes[Math.min(Math.max(0, state.index || 0), state.routes.length - 1)]
  if (route && route.state) return getActiveRouteName(route.state) || route.name
  return (route && route.name) || ""
}

/**
 * Wire directly to React Navigation:
 *   <NavigationContainer onStateChange={(s) => ReliaNative.trackNavigationState(s)}>
 * Expo Router users instead call ReliaNative.trackScreen(usePathname()) in their root layout.
 */
export function trackNavigationState(state: NavigationStateLike | null | undefined): void {
  const name = getActiveRouteName(state)
  if (name && screenTracker) screenTracker(name)
}
